export default "__VITE_ASSET___5d1X_FY__"